export default __webpack_public_path__ + "static/media/cp_geo_au.dd1760ce.svg";